import { identifyStonlyUser } from '@app/utils/externalModules/stonlyWidget';

import { loadHotjar } from './hotjar';
import { updateCSATUserVariable } from './ifmCSATModule';

export { updateCSATUserVariable, identifyStonlyUser };

export const loadExternalModules = async () => {
  loadHotjar();
};
